import React from 'react';
import BreadCrumb from 'Common/BreadCrumb';

const Analytics = () => {

  return (
    <React.Fragment>
      <BreadCrumb title='CrediApoyo' pageTitle='Dashboards' />
      <div className="grid grid-cols-12 gap-x-5">
      </div>
    </React.Fragment>
  );
};

export default Analytics;
